// Shows/hides the per-mode input blocks on the Merchandising "new" form.
// Each block declares the modes it belongs to via data-modes="mode_a mode_b".
//
// Markup expected:
//   <div data-controller="merch-mode">
//     <input type="radio" name="merchandising_generation[mode]" value="hanger_front"
//            data-merch-mode-target="modeInput" data-action="change->merch-mode#switch">
//     <div data-merch-mode-target="block" data-modes="hanger_front flatlay_folded">…</div>
//   </div>
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modeInput", "block"]

  connect() {
    this.switch()
  }

  currentMode() {
    const checked = this.modeInputTargets.find((i) => i.checked)
    return checked ? checked.value : null
  }

  switch() {
    const mode = this.currentMode()
    this.blockTargets.forEach((block) => {
      const modes = (block.dataset.modes || "").split(/\s+/)
      block.hidden = !modes.includes(mode)
    })
  }
}
